import { createSlice } from '@reduxjs/toolkit';
import { hydrateCart, requestCartItems } from '../helpers/externalRequests';


function setLocalStorage(items) {
  localStorage.setItem('closetCart', JSON.stringify(items.map((item) => {
    return {
      ...item,
      product: undefined,
      size: undefined
    }
  })));
  return items;
}

function getLocalStorage() {
  const raw = localStorage.getItem('closetCart');
  if (raw) {
    return JSON.parse(raw);
  }
  return [];
}

function calculateTotal(items) {
  return items.reduce((total, item) => total + item.qty, 0)
}

function createCartItem(product, size) {
  return {
    productId: product.id,
    sizeId: size.id,
    product,
    size,
    qty: 0
  }
}

function copyItems(items) {
  return JSON.parse(JSON.stringify(items))
}

function findProductSize(items, productId, sizeId) {
  return items.find(match => match.productId === productId && match.sizeId === sizeId)
}

function findOrCreateProductSize(items, product, size) {
  const newItems = copyItems(items)
  let item = findProductSize(newItems, product.id, size.id);

  if (!item) {
    item = createCartItem(product, size)
    newItems.push(item)
  }

  return {
    newItems,
    item
  }
}

function getInitialState() {
  const items = getLocalStorage()
  return {
    hydrated: items.length === 0,
    items,
    total: calculateTotal(items),
    missingItems: 0
  }
}

const closetCartSlice = createSlice({
  name: 'closetCart',
  initialState: getInitialState(),
  reducers: {
    addItem: (state, event) => {
      const { product, size, qty } = { qty: 1, ...event.payload }
      const { newItems, item } = findOrCreateProductSize(state.items, product, size)

      item.qty += qty

      setLocalStorage(newItems)
      return {
        ...state,
        items: newItems,
        total: calculateTotal(newItems)
      }
    },
    removeItems: (state, event) => {
      const newItems = state.items.filter(match => {
        return !event.payload.some(removed => match.productId === removed.productId && match.sizeId === removed.sizeId)
      });

      return {
        ...state,
        items: newItems,
        total: calculateTotal(newItems)
      }
    },
    clear: () => {
      return {
        hydrated: true,
        items: setLocalStorage([]),
        total: 0,
        missingItems: 0
      };
    },
    setItems: (state, event) => {
      const newItems = event.payload
      setLocalStorage(newItems)
      return {
        ...state,
        items: newItems,
        total: calculateTotal(newItems)
      };
    },
    setMissingItems: (state, event) => {
      const missingItems = event.payload
      return {
        ...state,
        missingItems
      };
    }
  },
});

export default closetCartSlice

export const hydrateItems = () => async (dispatch, getState) => {
  const { items } = getState().closetCart

  const res = await hydrateCart({ cartItems: items });

  dispatch(closetCartSlice.actions.setItems(res.data))
  const missingItems = items.length - res.data.length
  dispatch(closetCartSlice.actions.setMissingItems(missingItems))
}

export const requestItems = (requestData) => async (dispatch, getState) => {
  const { items } = getState().closetCart

  await requestCartItems({ ...requestData, cartItems: items });
  dispatch(closetCartSlice.actions.clear())
}
